import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues, Field } from 'redux-form'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { PHCont } from './styled'
import { StdCard } from 'components'
import { ProcessRow } from './ProcessRow'
import { Button, Modal } from 'semantic-ui-react'
import { addComment, getBillformDetail } from 'ducks/billform'

const BLProcessHistory = (props) => {
  const { blDetail, user, defaultExpand = true } = props
  const [showCommentModal, setShowCommentModal] = React.useState(false)
  const [comment, setComment] = React.useState('')

  const submitBillingCommentForm = () => {
    props.addComment(
      blDetail.id, 
      { comment: comment }, 
      () => { 
        setShowCommentModal(false)
        window.location.reload()
      })
  }

  return (
    <PHCont>
      <StdCard 
        title={<span className='stepTitle'>Comment History</span>} 
        style={{ flex: 1 }} 
        defaultExpand={defaultExpand}
        accessoriesHeader={
          blDetail.status === 27 && // Status Wait for Original Doc.
          (user.mainDeptCode === 'ACC' || user.subDeptCode === 'ACC') ? 
           <Button 
            type='button'
            content='Add Comment'
            color='blue'
            onClick={() => setShowCommentModal(true)}
           /> : null
        }
      >
        {
          blDetail && blDetail.billingComment.map((item, i) => {
            let files = blDetail.billingAttachment.filter(x => x.commentId === item.id)
            return (<ProcessRow data={item} files={files} />)
          })
        }
      </StdCard>
      <Modal open={showCommentModal}>
        <Modal.Header>Add Comment</Modal.Header>
        <Modal.Content>
          <form>
            <Field 
              name='comment' 
              label='Comment' 
              require 
              type={type.textArea} 
              specialOnChange={(data) => { setComment(data) }} 
              component={FieldInput} />
          </form>
        </Modal.Content>
        <Modal.Actions>
          <Button 
            type='button'
            content='Add Comment'
            color='blue'
            disabled={comment === ''}
            onClick={() => submitBillingCommentForm()}
           />
           <Button 
            type='button'
            content='Cancel'
            color='red'
            onClick={() => {
              setComment('')
              setShowCommentModal(false)
            }}
           />
        </Modal.Actions>
      </Modal>
    </PHCont>
  )
}

const mapStateToProps = state => {
  return {
    valueForm: getFormValues('formBillingAddComment')(state) || {},
    user: state.authen.user || {}
  }
}

const mapDispatchToProps = {
  addComment,
  getBillformDetail
}

const BillingAddCommentForm = reduxForm({
  form: 'formBillingAddComment',
  enableReinitialize: true,
})(BLProcessHistory)

export default connect(mapStateToProps, mapDispatchToProps)(BillingAddCommentForm)
